<template>
    <div class="w-full flex flex-col justify-center items-center">
        <div class="mb-6 text-center" :class="{'large:mb-14': !text}">
            <div class="heading-s xLarge:text-heading-s-lg">
                {{ title }}
            </div>
            <p v-if="text" class="mt-4 body-s">
                {{ text }}
            </p>
            <p v-if="partText" class="mt-4 body-s">
                ({{ partText }})
            </p>
        </div>
        <div
            v-if="currentValues?.length"
            :style="`--col-count-mobile: ${flexConfig?.mobile?.cols || 1};
                     --gap-mobile: ${flexConfig?.mobile?.gap || '0.5625rem'};
                     --col-count-desktop: ${flexConfig?.desktop?.cols || 1};
                     --gap-desktop: ${flexConfig?.desktop?.gap || '0.5625rem'};
                     --max-width-desktop: ${flexConfig?.desktop?.maxWidth || 'none'};`"
            class="w-full flex flex-wrap justify-center gap-[var(--gap-mobile)] large:gap-[var(--gap-desktop)] large:max-w-[var(--max-width-desktop)]"
        >
            <div
                v-for="(value, index) in currentValues"
                :key="index"
                class="flex w-[calc((100%_/_var(--col-count-mobile))_-_(0.5625rem_/_var(--col-count-mobile)))] large:w-[calc((100%_/_var(--col-count-desktop))_-_(1.25rem_/_var(--col-count-desktop)))]"
            >
                <button
                    class="heading-xxs relative p-2 w-full h-16 flex justify-center items-center gap-x-[0.5625rem] box-border rounded-[.5rem] hover:text-white hover:bg-primary"
                    :class="[
                        {'large:h-[9.4375rem]': flexConfig?.desktop?.tall},
                        selection === value.id || selectionArray.includes(value.id) ? 'text-white bg-primary' : 'text-text1 bg-secondary',
                        { 'pointer-events-none opacity-50' : maxSelectionReached && !selectionArray.includes(value.id) }
                    ]"
                    @click="handleSelection(value.id)"
                >
                    <img
                        v-if="value.icon"
                        class="w-4"
                        :class="{'brightness-0 invert': selection === value.id || selectionArray.includes(value.id)}"
                        :src="value.icon"
                    >
                    <span>
                        {{ value.title }}
                    </span>
                </button>
            </div>
        </div>
        <div v-if="error" class="text-red-500">
            {{ error }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'single'
            },
            title: {
                type: String,
                default: ''
            },
            text: {
                type: String,
                default: ''
            },
            partText: {
                type: String,
                default: ''
            },
            values: {
                type: Object,
                default: null
            },
            error: {
                type: String,
                default: ''
            },
            maxSelections: {
                type: Number,
                default: null
            },
            flexConfig: {
                type: Object,
                default: {}
            }
        },
        emits: [
            "valueChanged"
        ],
        data () {
            return {
                selection: null,
                selectionArray: [],
                maxSelectionReached: false,
                truefalseValues: [
                    {
                        id: "yes",
                        name: "Yes"
                    },
                    {
                        id: "no",
                        name: "No"
                    }
                ]
            }
        },
        computed: {
            currentValues () {
                return this.values ? this.values : this.truefalseValues;
            }
        },
        methods: {
            handleSelection (value) {
                if (this.type === 'multiple') {
                    if (this.selectionArray.includes(value)) {
                        const index = this.selectionArray.indexOf(value);
                        this.selectionArray.splice(index, 1);
                    } else {
                        if (value === 'none') {
                            this.selectionArray = [];
                        } else {
                            const index = this.selectionArray.indexOf('none');
                            if (index !== -1) {
                                this.selectionArray.splice(index, 1);
                            }
                        }
                        this.selectionArray.push(value);
                    }
                } else {
                    this.selection = value;
                }

                if (this.type === 'multiple' && this.maxSelections === this.selectionArray.length) {
                    this.maxSelectionReached = true;
                } else {
                    this.maxSelectionReached = false;
                }

                this.$emit('valueChanged', this.type === 'multiple' ? this.selectionArray : this.selection);
            }
        }
    };
</script>
